import React from "react";
import "./About.scss";

import { motion } from "framer-motion";
import portfolio from "../../../assets/portfolio.jpg";
const About = () => {
  return (
    <div className="container " id="about">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>Who Am I?</span>
        <h1>About Me</h1>
      </motion.div>

      <div className="about_container">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [-250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="about_left"
        >
          <motion.img
            src={portfolio}
            whileHover={{ y: -48, x: -55 }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
        <motion.div
          className="about_right"
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <p>
            I am a beginner in Programming and Web Development community. Last
            one year was very hard time for me as a beginner. I worked hard to
            learn many technologies.Such as React.js, Node.js, JavaScript, HTML,
            CSS, MongoDB, Github, Firebase, Heroku etc. I Challenged myself to
            learn TypeScript, ReactNative, Redux, JQuery in next six months.
            After six month I want to see myself as a proper MERN Stack Web
            Developer. I'm trying hard and soul to achieve my goal.
          </p>

          <motion.a
            href="#contact"
            whileHover={{ scale: 1.1 }}
            animate="animation"
            transition={{ duration: 0.5 }}
          >
            Contact Me
          </motion.a>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
